import { render, staticRenderFns } from "./CollectionAvailability.vue?vue&type=template&id=7a17529e&"
import script from "./CollectionAvailability.vue?vue&type=script&lang=js&"
export * from "./CollectionAvailability.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAvailability.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports